import { Flex, Tooltip } from '@aloft/toolkit-sui';

import { Caret } from '../../components/Caret.tsx';
import { TooltipContent } from './TooltipContent.tsx';

export function AdjustmentTooltip(breakdown: { calculations?: string[]; description?: string }) {
  if (!breakdown.description) {
    return null;
  }
  return (
    <Tooltip placement="top" openDelay={500} label={<TooltipContent {...breakdown} />}>
      <Flex cursor="help">
        <Caret />
      </Flex>
    </Tooltip>
  );
}
